const ContactSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M11.666 1.33594H5.33268C3.85992 1.33594 2.66602 2.52984 2.66602 4.0026V12.0026C2.66602 13.4754 3.85992 14.6693 5.33268 14.6693H11.666C13.1388 14.6693 14.3327 13.4754 14.3327 12.0026V4.0026C14.3327 2.52984 13.1388 1.33594 11.666 1.33594Z"
        stroke="#333333"
        strokeWidth="1.12683"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.05935 9.16391C6.64002 9.44524 5.54135 10.0186 6.21068 10.7359C6.53735 11.0866 6.90202 11.3372 7.35935 11.3372H9.97268C10.43 11.3372 10.7947 11.0866 11.1213 10.7359C11.7907 10.0186 10.692 9.44524 10.2727 9.16457C9.79869 8.84271 9.23896 8.67063 8.66602 8.67063C8.09307 8.67063 7.53334 8.84271 7.05935 9.16457M3.33268 4.00391H1.66602M3.33268 8.00391H1.66602M3.33268 12.0039H1.66602M9.99935 6.00391C9.99935 6.35753 9.85887 6.69667 9.60882 6.94672C9.35878 7.19676 9.01964 7.33724 8.66602 7.33724C8.31239 7.33724 7.97326 7.19676 7.72321 6.94672C7.47316 6.69667 7.33268 6.35753 7.33268 6.00391C7.33268 5.65028 7.47316 5.31115 7.72321 5.0611C7.97326 4.81105 8.31239 4.67057 8.66602 4.67057C9.01964 4.67057 9.35878 4.81105 9.60882 5.0611C9.85887 5.31115 9.99935 5.65028 9.99935 6.00391Z"
        stroke="#333333"
        strokeWidth="0.965851"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ContactSvg;
